module.exports = __webpack_public_path__ + "static/media/main_banner_05.ef9f7dbc.png";